module.exports = __webpack_public_path__ + "img/icon-warning-generic-red.c9cad15e.svg";